module.exports = __webpack_public_path__ + "8a5356e9/img/google.68f3823e.svg";